module.exports = __webpack_public_path__ + "img/invite_link.250e2592.svg";